/**
 * readableTranscript — browser dictation made readable (Plan H).
 *
 * Mirrors backend/app/services/transcript_format.py, which does the same
 * for PE transcripts; keep the two in step. Spoken "comma", "period",
 * "question mark" and friends become their marks, sentences get capitals,
 * a final stop is added. No word is dropped, added or reordered except
 * the punctuation words themselves. "period" stays a word after a
 * determiner ("her period").
 */
const MARKS = [
  [/exclamation (?:point|mark)/gi, "!"],
  [/question mark/gi, "?"],
  [/full stop/gi, "."],
  [/new paragraph/gi, "\n\n"],
  [/new line/gi, "\n"],
  [/semi-?colon/gi, ";"],
  [/comma/gi, ","],
  [/period/gi, "."],
];

const PERIOD_GUARD = new Set([
  "a", "an", "the", "her", "his", "my", "your", "their", "our", "its", "this", "that",
  "each", "every", "first", "second", "third", "last", "next", "same", "long", "short",
  "quiet", "rest", "time", "of", "during", "menstrual", "grace", "trial", "waiting",
]);

function isWordChar(ch) { return !!ch && /[\w']/.test(ch); }

export function readableTranscript(text) {
  if (!text) return "";
  let out = String(text);
  for (const [rx, mark] of MARKS) {
    out = out.replace(rx, (m, offset, whole) => {
      // whole-word only
      if (isWordChar(whole[offset - 1]) || isWordChar(whole[offset + m.length])) return m;
      if (mark === "." && /period/i.test(m)) {
        const before = whole.slice(0, offset).match(/(\w+)\W*$/);
        if (before && PERIOD_GUARD.has(before[1].toLowerCase())) return m;
      }
      return mark;
    });
  }
  out = out
    .replace(/[ \t]+([,.;!?])/g, "$1")
    .replace(/([,.;!?])(?=[^\s\n,.;!?])/g, "$1 ")
    .replace(/([.!?])(?:\s*[.!?])+/g, "$1")
    .replace(/,(?:\s*,)+/g, ",")
    .replace(/\n[ \t]*[,.;]+/g, "\n")
    .replace(/[ \t]*\n[ \t]*/g, "\n")
    .replace(/[ \t]{2,}/g, " ")
    .trim()
    .replace(/^[,.;!?\s]+/, "");
  out = out.replace(/(^|[.!?]\s+|\n+)([a-z])/g, (m, a, b) => a + b.toUpperCase());
  out = out.replace(/\bi\b/g, "I");
  if (out && !/[.!?]$/.test(out)) out += ".";
  return out;
}
